import React from 'react';

import { InputWithError } from './imports';
import { DateRangePickerInput } from '@dom/components';
// import { useFormValidator } from '@sharingapples/form';
 
export default function GuideBookingDates(props) {
  // const error = useFormValidator('startDate', Validators.required('Please inform us your booking dates'));
  return (
    <InputWithError
      Type={DateRangePickerInput}
      endDateName="endDate"
      startDateName="startDate"
      placeholder="Start - End Dates"
      // parentError={error}
      {...props}
    />
  );
}
